import {Subject, Subscription} from 'rxjs';

export class AnonymousSubject extends Subject {
  constructor(destination, source) {
    super();
    this.destination = destination;
    this.source = source;
  }
  next(value) {
    const {destination} = this;
    if (destination && destination.next) {
      destination.next(value);
    }
  }
  error(err) {
    const {destination} = this;
    if (destination && destination.error) {
      this.destination.error(err);
    }
  }
  complete() {
    const {destination} = this;
    if (destination && destination.complete) {
      this.destination.complete();
    }
  }
  /** @deprecated This is an internal implementation detail, do not use. */
  _subscribe(subscriber) {
    const {source} = this;
    if (source) {
      return this.source.subscribe(subscriber);
    }
    return Subscription.EMPTY;
  }
}
